/**
 * Whose turn it is in a chat, and the order of the chat list.
 *
 * The server decides `is_my_turn` (backend services/reply_turn.py: the other
 * person wrote last in a live chat) and orders the list by it - Hinge's
 * proven "your turn first". These keep a row right between two fetches, when
 * a message arrives or is sent, with the same rule and the same order.
 */

/** A message a person wrote; a system line never moves the turn. */
export const isHumanMessage = (message) =>
  Boolean(message) && message.message_type !== 'system' && message.sender_id !== 'system';

/** The turn after `message` lands in `conversation`, seen by `viewerId`. */
export const turnAfter = (conversation, message, viewerId) => {
  if (!isHumanMessage(message)) return Boolean(conversation?.is_my_turn);
  if (conversation?.status && conversation.status !== 'active') return false;
  return message.sender_id !== viewerId;
};

const timeOf = (conversation) =>
  new Date(conversation?.last_message_at || conversation?.created_at || 0).getTime() || 0;

/** Chats waiting on the viewer first, then newest first. */
export const orderConversations = (conversations) =>
  [...(conversations || [])].sort((a, b) =>
    (Number(Boolean(b.is_my_turn)) - Number(Boolean(a.is_my_turn))) || (timeOf(b) - timeOf(a)));
